import { takeEvery, put } from "redux-saga/effects";
import {
    GetSlideStockDocument,
    GetSlideStockDocumentCompleted,
    GetVideoDocument,
    GetVideoDocumentCompleted,
} from "../actions/DocumentActions";
import DocumentApi from "../apis/DocumentApi";
import DocumentEvent from "../events/DocumentEvent";

// slidestck資料ダウンロード
function* GetSlideStockDocumentStartedWorker({
    id,
    fileName,
}: ReturnType<typeof GetSlideStockDocument>) {
    const url: string = yield DocumentApi.getSlideStockDocument(id, fileName);
    yield put(GetSlideStockDocumentCompleted(url));
}

// 動画資料ダウンロード
function* GetVideoDocumentStartedWorker({ id, fileName }: ReturnType<typeof GetVideoDocument>) {
    const url: string = yield DocumentApi.getVideoDocument(id, fileName);
    yield put(GetVideoDocumentCompleted(url));
}

export default function* StatisticSaga() {
    yield takeEvery(DocumentEvent.GetSlideStockDocumentStarted, GetSlideStockDocumentStartedWorker);
    yield takeEvery(DocumentEvent.GetVideoDocumentStarted, GetVideoDocumentStartedWorker);
}
